import { cn } from '@/lib/utils'
import type { PanelArtProps } from './panel-art-props'

/**
 * Price Alerts panel art: a price line rising through a dashed alert level,
 * with a ring where it crosses, over two alert rows.
 */
export function PriceAlertsArt({ className }: PanelArtProps) {
  return (
    <svg
      viewBox="0 0 160 100"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
      focusable="false"
      className={cn('h-full w-full', className)}
    >
      <line
        x1={14}
        y1={30}
        x2={146}
        y2={30}
        stroke="hsl(var(--primary))"
        strokeWidth="1.5"
        strokeDasharray="4 3"
        vectorEffect="non-scaling-stroke"
      />
      <path
        d="M14 58 L32 52 L48 56 L66 44 L82 47 L98 30 L114 24 L130 27 L146 18"
        fill="none"
        stroke="hsl(var(--chart-candle-up))"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
      />
      <circle
        cx={98}
        cy={30}
        r={5}
        fill="none"
        stroke="hsl(var(--primary))"
        strokeWidth="2"
        vectorEffect="non-scaling-stroke"
      />
      {[72, 86].map((y, i) => (
        <g key={y}>
          <rect
            x={14}
            y={y - 4}
            width={20}
            height={8}
            rx={3}
            fill="hsl(var(--foreground) / 0.22)"
          />
          <rect
            x={40}
            y={y - 2}
            width={i ? 30 : 42}
            height={4}
            rx={2}
            fill="hsl(var(--foreground) / 0.12)"
          />
          <rect x={120} y={y - 4} width={26} height={8} rx={4} fill="hsl(var(--primary) / 0.35)" />
        </g>
      ))}
    </svg>
  )
}
